import { Link } from "react-router-dom"
import React from "react"
import apple from "~/images/landing/download-ios.png"
import google from "~/images/landing/download-google.png"
import stars from "~/images/landing/stars.png"
import { getMetaContent } from "~/common/get-meta-content"
import { cn } from "~/common/cn"

type FooterLinkProps = {
  children: React.ReactNode
  to?: string
  href?: string
  className?: string
}

export const FooterLink = ({ children, to, href, className = "" }: FooterLinkProps) => {
  const baseClasses = "font-md-nichrome text-24 uppercase leading-8 text-base-black"
  if (href) {
    return (
      <div className={cn(baseClasses, className)}>
        <a href={href}>{children}</a>
      </div>
    )
  }

  return (
    <div className={cn(baseClasses, className)}>
      <Link to={to || "#"}>{children}</Link>
    </div>
  )
}

export const Copyright = ({ className = "" }: { className?: string }) => (
  <div className={cn("font-inter text-10 leading-5 text-base-black opacity-75", className)}>
    ©2025 ChatBCC, Inc.
  </div>
)

type StarsProps = {
  className?: string
}

export const Stars = ({ className = "" }: StarsProps) => (
  <div className={className}>
    <img src={stars} alt="Stars" />
  </div>
)

type AppDownloadProps = {
  className?: string
  appleLink?: string
  googleLink?: string
}

export const AppDownload = ({
  className = "",
  appleLink = getMetaContent<string>("APP_STORE_URL"),
  googleLink = getMetaContent<string>("PLAY_STORE_URL"),
}: AppDownloadProps) => {
  return (
    <div className={cn("flex flex-row", className)}>
      <Link to={appleLink}>
        <img src={apple} alt="Download on App Store" className="h-[48px] w-[144px]" />
      </Link>
      <Link to={googleLink}>
        <img src={google} alt="Get it on Google Play" className="ml-4 h-[48px] w-[144px]" />
      </Link>
    </div>
  )
}
